

exports.__esModule = true;
exports.deOfferEligibleCartAmount = exports.deContentKeys = undefined;

var _squid = require('squid');

var domain = _squid.$meta.domain,
    cdnHost = _squid.$meta.cdnHost;
var deContentKeys = exports.deContentKeys = {
    reuse: {
        installment: {
            logo: 'https://' + cdnHost + '/webstatic/credit/img/pp-ratenzahlung-logo.png',
            bodyText: 'offers.deReuseBodyText',
            bodyText2: 'offers.deReuseBodyText2',
            termsText: 'offers.deReuseTermsText'
        }
    },
    acq: {
        installment: {
            logo: 'https://' + cdnHost + '/webstatic/credit/img/pp-ratenzahlung-logo.png',
            bodyText: 'offers.deBodyText',
            bodyText2: 'offers.deBodyText2',
            termsText: 'offers.deTermsText',
            termsLinkText: 'offers.deTermsLinkText',
            termsLink: 'https://www.' + domain + '/ppclander',
            statusText: 'offers.deStatusText'
        }
    }
};

var deOfferEligibleCartAmount = exports.deOfferEligibleCartAmount = {
    min: 99,
    max: 5000,
    currency: 'EUR'
};

_squid.$meta;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js
// module id = ../node_modules/xo-credit-components/src/xo-credit-offer-banners/de-banner/constants.js
// module chunks = 0